import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Creates a pending pattern document in Firestore
 * This document stores the pattern parameters before checkout/generation
 *
 * @param {string} uid - User ID
 * @param {string} patternId - Pattern ID to use as the document ID
 * @param {object} data - Pattern data
 *   - type: 'library' | 'user'
 *   - fileName?: string (library patterns only)
 *   - fileName2?: string (library lenticular secondary)
 *   - tempImagePath?: string (user primary image path)
 *   - tempImagePath2?: string (user secondary image path)
 *   - bookParams: { height, lastOddPage, angleLine, isInkSaver, measurementUnit, extraFrontPages, extraBackPages }
 *   - priceId?: string (absent for subscribed users)
 *   - productId?: string (absent for subscribed users)
 *
 * @returns {Promise<string>} The pattern ID (document ID)
 */
export const createPendingPattern = async (uid, patternId, data) => {
	const docRef = doc(db, `customers/${uid}/pendingPatterns/${patternId}`);
	await setDoc(docRef, {
		...data,
		createdAt: serverTimestamp(),
	});

	return patternId;
};
